module.exports = __webpack_public_path__ + "img/serbia.aeeefda6.svg";